export function removeAll<Type>(
    array: Array<Type>,
    functionUsedToRemove: (x: Type) => boolean
): Array<Type> {
    return array.filter((x) => !functionUsedToRemove(x));
}
